const Ticket = {

    // PAGE HEADER
    "tickets": "Tickets",
    "ticket": "Ticket",
    "create_ticket": "Create Ticket",
    "ticket_details": "Ticket Details",
    "search": "Search",

    // FIELDS
    "name": "Name",
    "username": "Username",
    "email": "Email",
    "mobile": "Mobile",
    "title": "Title",
    "case_reason": "Case Reason",
    "description": "Description",
    "remark": "Remark",
    "remarks_history": "Remarks History",
    "status": "Status",
    "reason": "Reason",
    "logged_date": "Logged Date",
    "ticket_no": "Ticket No",
    "no_remarks": "No public remarks yet",

    // PLACEHOLDER
    "ph_title": "Enter Title",
    "ph_case_reason": "Select Case Reason",
    "ph_description": "Enter Description",
    "ph_remark": "Enter Remark",

    // ERROR
    "error_required": "This field is required.",

    // TOAST (same text as portal)
    "success_add": "Case has been saved successfully",
    "success_remark": "Remark has been saved successfully",

    // TABLE HEADER
    "table_ticket_no": "TICKET NO",
    "table_title": "TITLE",
    "table_logged_date": "LOGGED DATE",
    "table_reason": "REASON",
    "table_status": "STATUS",

}

export default Ticket;
